
import { BasicComboboxEvent } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2RankingDataEvent } from "../../../event/Poker2RankingDataEvent";
import { HallOfFameVO } from "../../../gamevo/HallOfFameVO";
import { Poker2Model } from "../../../model/Poker2Model";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class Poker2RankingTabHalloffame {
    private MAX_RANKINGLINES: number = 7;

    private disp: MovieClip;	//	rankingDialog.mc_halloffame
    private selectedLine: Library.PokerInterface.RankingHallOffameLine;
    public monthComboBox: Poker2DynamicCombobox;
    public yearComboBox: Poker2DynamicCombobox;
    private currentDate: Date;

    /**
     * @param disp
     * @param monthHallComboBox
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
        this.monthComboBox = new Poker2DynamicCombobox(disp.combo_month);
        this.yearComboBox = new Poker2DynamicCombobox(disp.combo_year);
    }

    public applyProperties(): void {
        this.disp.txt_sortrank.mouseEnabled = false;
        this.disp.txt_sortname.mouseEnabled = false;
        this.disp.txt_sortxp.mouseEnabled = false;
        this.initTextFields();
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox);
    }

    public initTextFields(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortrank,
            Poker2Model.languageData.getTextById("dialog_ranking_rank"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortname,
            Poker2Model.languageData.getTextById("dialog_ranking_name"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortxp,
            Poker2Model.languageData.getTextById("dialog_ranking_points"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_month,
            Poker2Model.languageData.getTextById("dialog_ranking_month"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_year,
            Poker2Model.languageData.getTextById("dialog_ranking_year"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_title,
            Poker2Model.languageData.getTextById("dialog_ranking_halloffame"));
    }

    public show(): void {
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox);
        this.monthComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onMonthComboboxChange));
        this.yearComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
        this.controller.addEventListener("changeHallofFameData", this.bindFunction(this.onChangeHallofFameData));
    }
    public hide(): void {
        this.monthComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onMonthComboboxChange));
        this.yearComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
        this.controller.removeEventListener("changeHallofFameData", this.bindFunction(this.onChangeHallofFameData));
    }
    private onMonthComboboxChange(event: BasicComboboxEvent): void {
        this.getListFromServer();
    }
    private onYearComboboxChange(event: BasicComboboxEvent): void {
        this.yearComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));

        var yearSort: number = int(this.yearComboBox.selectedId + 2011);
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox, -1, yearSort);

        this.yearComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
    }
    private onChangeHallofFameData(event: Poker2RankingDataEvent): void {
        this.fillHallofFame(Poker2Model.rankingData.halloffameRankList);
    }

    public onClick(event: MouseEvent): void {
        var startRank: number = 0;

        switch (event.target) {
            case this.disp.btn_up:
                if (event.target.properties > this.MAX_RANKINGLINES) {
                    startRank = int(event.target.properties - this.MAX_RANKINGLINES);
                    this.getListFromServer(startRank);
                }
                break;
            case this.disp.btn_down:
                this.getListFromServer(event.target.properties);
                break;
            default:
                if (instanceOfClass(event.target, "RankingHallOffameLine")) {
                    Poker2RankingDialog.getAvatarCard(event.target.properties);
                    this.activateHallRankLine(event.target as Library.PokerInterface.RankingHallOffameLine);
                }
                break;
        }
    }

    public onMouseOver(event: MouseEvent): void {
        if (event.target != this.selectedLine)
            (event.target as Library.PokerInterface.RankingHallOffameLine).mc_background.gotoAndStop(2);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public onMouseOut(event: MouseEvent): void {
        if (event.target != this.selectedLine)
            (event.target as Library.PokerInterface.RankingHallOffameLine).mc_background.gotoAndStop(1);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    public getListFromServer(startR: number = 1): void {
        var monthSort: number = int(this.monthComboBox.selectedId + 1);
        var yearSort: number = int(this.yearComboBox.selectedId + 2011);
        if (yearSort == 2011) {
            monthSort += int(9 - 1);
        }
        var paramObject: any = { month: monthSort, year: yearSort, startRank: startR };
        BasicModel.smartfoxClient.sendMessage("rhf", [JSON.stringify(paramObject)]);
    }

    public fillHallofFame(hallofFameRanking: HallOfFameVO[]): void {
        this.selectedLine = null;
        for (var i: number = 0; i < this.MAX_RANKINGLINES; i++) {
            var tItem: Library.PokerInterface.RankingHallOffameLine = this.disp["line" + i] as Library.PokerInterface.RankingHallOffameLine;
            if (hallofFameRanking.length - 1 < i) {
                tItem.visible = false;
                continue;
            }
            tItem.mc_background.gotoAndStop(1);
            if (i == 0)
                this.disp.btn_up.properties = hallofFameRanking[i].rang;
            if (i == this.MAX_RANKINGLINES - 1)
                this.disp.btn_down.properties = hallofFameRanking[i].rang + 1;

            tItem.visible = true;
            tItem.properties = hallofFameRanking[i].id;
            tItem.txt_tables_0.text = NumberStringHelper.groupString(hallofFameRanking[i].rang, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_1.text = hallofFameRanking[i].name;
            tItem.txt_tables_2.text = NumberStringHelper.groupString(hallofFameRanking[i].points, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.mouseChildren = false;
        }
    }

    private activateHallRankLine(table: Library.PokerInterface.RankingHallOffameLine): void {
        if (this.selectedLine != table) {
            if (this.selectedLine)
                this.selectedLine.mc_background.gotoAndStop(1);
            this.selectedLine = table;
            this.selectedLine.mc_background.gotoAndStop(2);
        }
    }

    //
    // getter & setter
    //

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    //
    // ende
    //
}
import { Poker2RankingDialog } from "../../dialogs/ranking/Poker2RankingDialog";
import { Poker2LayoutManager } from "../../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {Poker2DynamicCombobox} from "../Poker2DynamicCombobox";
